export default __webpack_public_path__ + "static/media/theme_asien.d649cdf3.jpg";